import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Icon } from 'react-icons-kit';
import { map } from 'react-icons-kit/feather/map';
import { download } from 'react-icons-kit/fa/download';
import { ic_remove_red_eye } from 'react-icons-kit/md/ic_remove_red_eye';

import Button from 'components/Button/Button';
import CustomModal from 'components/CustomModal/CustomModal';

import { initInfoMap } from 'utils/Visor';

import './Info.css';

declare var Viewer;

class Info extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  download = (sheet) => {
    const files = this.props.data.resources.filter((rr) => {
      return rr.format === 'ZIP';
    });

    let url = files[0].url;
    if (sheet !== undefined && sheet === 2) {
      url = files[1].url;
    }

    window.open(url);
  }

  showImage = (sheet) => {
    let elem = document.querySelector('.imageContainer img');
    if (sheet === 1 || sheet === 2) {
      elem = document.querySelector(`.imageContainer${sheet} img`);
    }

    const viewer = new Viewer(elem, {
      inline: false,
      title: false,
      rotatable: true,
      fullscreen: true,
      navbar: false,
      toolbar: {
        zoomIn: true,
        zoomOut: true,
        rotateLeft: true,
        rotateRight: true,
      },
      initialCoverage: 0.9,
    });

    viewer.show();
    setTimeout(() => {
      document.querySelector('.viewer-button.viewer-close').addEventListener('click', () => {
        viewer.destroy();
      });

      document.onkeydown = (evt) => {
        evt = evt || window.event;
        let isEscape = false;
        if ('key' in evt) {
            isEscape = (evt.key === 'Escape' || evt.key === 'Esc');
        } else {
            isEscape = (evt.keyCode === 27);
        }

        if (isEscape) {
            viewer.destroy();
        }
      };
    }, 120);
  }

  showMap = () => {
    this.setState({ open: true }, () => {
      document.querySelector('#infoMapModal').parentElement.style.padding = '0';
      setTimeout(() => {
        const wms = this.props.data.resources.filter((rr) => {
          return rr.resource_type === 'WMS';
        })[0];

        const png = this.props.data.resources.filter((rr) => {
          return rr.resource_type === 'PNG';
        })[0];

        initInfoMap(png.url.split('&LAYERS=')[1].split('&')[0], this.props.data.title, wms.url, JSON.parse(this.props.data.spatial));
      }, 200);
    });
  }

  modifyImageUrl = (url) => {
    const newWidth = parseInt(url.split('&WIDTH=')[1].split('&')[0], 10) * 2;
    const newHeight = parseInt(url.split('&HEIGHT=')[1].split('&')[0], 10) * 2;
    return `${url.split('&WIDTH=')[0]}&WIDTH=${newWidth}&HEIGHT=${newHeight}&${url.split('&HEIGHT=')[1].split('&')[1]}`;
  }

  render() {
    const { variant, data } = this.props;
    let images = data.resources.filter((rr) => {
      return rr.resource_type === 'Previsualizacion';
    });

    let image = images[0];
    if (variant !== 'cartografia-antigua') {
      image = data.resources.filter((rr) => {
        return rr.resource_type === 'PNG';
      })[0];
    } else if (data.signature.indexOf('ATL') > -1) {
      images = data.resources.filter((rr) => {
        return rr.resource_type === 'Miniatura';
      });

      image = images[0];
    }

    const isDownloable = data.resources.filter((rr) => {
      return rr.format === 'ZIP';
    }).length > 0;

    const hasWMS = data.resources.filter((rr) => {
      return rr.resource_type === 'WMS';
    }).length > 0;

    return (
      <div className='infoContainer'>
        { variant === 'cartografia-antigua' ?
          <div style={{ display: 'flex', marginTop: '-20px', marginLeft: (images.length === 1 && image !== undefined) ? '2rem' : 'unset' }}>
            { images.length === 1 && image !== undefined ?
              <div className='imageContainer'>
                <div>
                  <img src={image.url} alt={data.title} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  { isDownloable ?
                    <Button text={'Descargar'} number={1} active={true} onClick={this.download}>
                      <span>&nbsp;&nbsp;&nbsp;<Icon size={'18px'} icon={download} /></span>
                    </Button>
                  : null }
                  <Button text={'Vista previa'} number={2} active={true} onClick={this.showImage}>
                    <span>&nbsp;&nbsp;&nbsp;<Icon size={'18px'} icon={ic_remove_red_eye} /></span>
                  </Button>
                </div>
              </div>
            : images.length > 1 && image !== undefined ?
              <div className='imagesContainer'>
                <div className='imageContainer imageContainer1'>
                  <div>
                    <img src={images[0].url} alt={data.title} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    { isDownloable ?
                      <Button text={'Descargar'} number={1} active={true} onClick={this.download.bind(null, 1)}>
                        <span>&nbsp;&nbsp;&nbsp;<Icon size={'18px'} icon={download} /></span>
                      </Button>
                    : null }
                    <Button text={'Vista previa'} number={2} active={true} onClick={this.showImage.bind(null, 1)}>
                      <span>&nbsp;&nbsp;&nbsp;<Icon size={'18px'} icon={ic_remove_red_eye} /></span>
                    </Button>
                  </div>
                </div>
                <div className='imageContainer imageContainer2'>
                  <div>
                    <img src={images[1].url} alt={data.title} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    { isDownloable ?
                      <Button text={'Descargar'} number={1} active={true} onClick={this.download.bind(null, 2)}>
                        <span>&nbsp;&nbsp;&nbsp;<Icon size={'18px'} icon={download} /></span>
                      </Button>
                    : null }
                    <Button text={'Vista previa'} number={2} active={true} onClick={this.showImage.bind(null, 2)}>
                      <span>&nbsp;&nbsp;&nbsp;<Icon size={'18px'} icon={ic_remove_red_eye} /></span>
                    </Button>
                  </div>
                </div>
              </div>
            : null }
            <div className='infoOld'>
              <div className='attributeField'>
                <div className='row attribute-title'>
                  {'Título'}
                </div>
                <div className='row attribute-value'>
                  {data.title !== undefined ? data.title : 'Información no disponible'}
                </div>
              </div>
              <div className='attributeField'>
                <div className='row attribute-title'>
                  {'Autor (es) o entidad'}
                </div>
                <div className='row attribute-value'>
                  {data.map_creator !== undefined ? data.map_creator : 'Información no disponible'}
                </div>
              </div>
              <div className='attributeField'>
                <div className='row attribute-title'>
                  {'Lugar de edición y editor'}
                </div>
                <div className='row attribute-value'>
                  {data.editorial !== undefined ? data.editorial.replaceAll('[', '').replaceAll(']', '') : 'Información no disponible'}
                </div>
              </div>
              <div className='attributeField'>
                <div className='row attribute-title'>
                  {'Año'}
                </div>
                <div className='row attribute-value'>
                  {data.date !== undefined && !(data.date.substring(0, 4) === '9999' || data.date.substring(0, 4) === '19sa') ? data.date.substring(0, 4) : 'Información no disponible'}
                </div>
              </div>
              <div className='attributeField'>
                <div className='row attribute-title'>
                  {'Descripción física'}
                </div>
                <div className='row attribute-value'>
                  {data.description !== undefined ? data.description.split('-')[0].trim() : 'Información no disponible'}
                </div>
              </div>
              <div className='attributeField'>
                <div className='row attribute-title'>
                  {'Escala'}
                </div>
                <div className='row attribute-value'>
                  {data.description !== undefined && data.description.indexOf('-') > -1 ? data.description.split('-')[1].replaceAll('Escala', '').trim() : 'Información no disponible'}
                </div>
              </div>
              <div className='attributeField'>
                <div className='row attribute-title'>
                  {'Signatura'}
                </div>
                <div className='row attribute-value'>
                  {data.signature !== undefined ? data.signature : 'Información no disponible'}
                </div>
              </div>
              <div className='attributeField'>
                <div className='row attribute-title'>
                  {'Metadato'}
                </div>
                <div className='row attribute-value'>
                  {data.url_metadata !== undefined  && data.url_metadata.indexOf('http') > -1 ?
                    <a href={data.url_metadata} target='_blank' rel='noreferrer noopener'>{data.url_metadata}</a>
                  : 'Información no disponible'}
                </div>
              </div>
              <div className='attributeField'>
                <div className='row attribute-title'>
                  {'Notas'}
                </div>
                <div className='row attribute-value'>
                  {data.notes !== undefined ? data.notes : 'Información no disponible'}
                </div>
              </div>
              <div className='attributeField'>
                <div className='row attribute-title'>
                  {'Derechos'}
                </div>
                <div className='row attribute-value'>
                  <a href='https://creativecommons.org/licenses/by/4.0/deed.en' target='_blank' rel='noreferrer noopener'>https://creativecommons.org/licenses/by/4.0/deed.en</a>
                </div>
              </div>
            </div>
          </div>
          : <div style={{ display: 'flex', marginTop: '-20px' }}>
              { image !== undefined ?
                <div className='imageContainer'>
                  <div>
                    <img src={this.modifyImageUrl(image.url)} alt={data.title} />
                  </div>
                  <div className={!isDownloable ? 'infoBtnContainer' : 'infoBtnContainer2'}>
                    { isDownloable ?
                      <Button text={'Descargar'} number={1} active={true} onClick={this.download}>
                        <span>&nbsp;&nbsp;&nbsp;<Icon size={'18px'} icon={download} /></span>
                      </Button>
                    : null }
                    <Button text={'Vista previa'} number={2} active={true} onClick={this.showImage}>
                      <span>&nbsp;&nbsp;&nbsp;<Icon size={'18px'} icon={ic_remove_red_eye} /></span>
                    </Button>
                    { hasWMS && variant !== 'planimetrias-y-altimetrias' ?
                      <Button text={'Ver en visualizador'} number={3} active={true} onClick={this.showMap}>
                        <span>&nbsp;&nbsp;&nbsp;<Icon size={'18px'} icon={map} /></span>
                      </Button>
                    : null }
                  </div>
                </div>
              : null }
              <div className='infoOthers'>
                <div className='attributeField'>
                  <div className='row attribute-title'>
                    {'Título'}
                  </div>
                  <div className='row attribute-value'>
                    {data.title !== undefined ? data.title : 'Información no disponible'}
                  </div>
                </div>
                <div className='attributeField'>
                  <div className='row attribute-title'>
                    {'Autor (es) o entidad'}
                  </div>
                  <div className='row attribute-value'>
                    {data.map_creator !== undefined ? data.map_creator : 'Información no disponible'}
                  </div>
                </div>
                <div className='attributeField'>
                  <div className='row attribute-title'>
                    {'Año'}
                  </div>
                  <div className='row attribute-value'>
                    {data.date !== undefined && !(data.date.substring(0, 4) === '9999' || data.date.substring(0, 4) === '19sa') ? data.date.substring(0, 4) : 'Información no disponible'}
                  </div>
                </div>
                <div className='attributeField'>
                  <div className='row attribute-title'>
                    {'Colección'}
                  </div>
                  <div className='row attribute-value'>
                    {data.collection !== undefined ? data.collection : 'Información no disponible'}
                  </div>
                </div>
                <div className='attributeField'>
                  <div className='row attribute-title'>
                    {'Escala'}
                  </div>
                  <div className='row attribute-value'>
                    {data.scale !== undefined ? data.scale.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : 'Información no disponible'}
                  </div>
                </div>
                <div className='attributeField'>
                  <div className='row attribute-title'>
                    {'Metadato'}
                  </div>
                  <div className='row attribute-value'>
                    {data.map_metadata !== undefined  && data.map_metadata.indexOf('http') > -1 ?
                      <a href={data.map_metadata} target='_blank' rel='noreferrer noopener'>{data.map_metadata}</a>
                    : 'Información no disponible'}
                  </div>
                </div>
                <div className='attributeField'>
                  <div className='row attribute-title'>
                    {'Notas'}
                  </div>
                  { data.notes !== undefined ?
                    <div className='row attribute-value' dangerouslySetInnerHTML={{ __html: data.notes.replaceAll('\n', '<br/>') }}>
                    </div>
                  : <div className='row attribute-value'>Información no disponible</div> }
                </div>
              </div>
          </div>}
          <CustomModal open={this.state.open} onClose={this.handleClose} title={'Visualizador'} id='infoMapModal'>
            <div id='infoMap'></div>
          </CustomModal>
      </div>
    );
  }
}

export default translate()(Info);
